import React from "react";

import './quiz-header-styles.css';

const StudentQuizVisualizerHeader = () => {
    return (
        <div className = "quiz-header">
            <h1>Cabecera del formulario (título)</h1>
        </div>
    );
};

export default StudentQuizVisualizerHeader;